import styled from 'styled-components/macro';

export const CardWrapper = styled.div`
  width: 160px;
`;
